"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIconConfig = void 0;
var defaultIconConfig = {
    margin: {
        fullHd: '0 10px 0 0',
        widescreen: '0 10px 0 0',
        desktop: '0 10px 0 0',
        tablet: '0 10px 0 0',
        mobile: '0 10px 0 0'
    }
};
exports.defaultIconConfig = defaultIconConfig;
//# sourceMappingURL=DescriptionIcon.js.map